// Init and load phone numbers
let allCountries = [];
let JSONfile = document.getElementById("JSONfile").innerHTML;
document.getElementById("custom_phone_number").addEventListener("keyup", updateInputValue);

fetch(JSONfile).then((res) => { return res.json();}).then((data) => passValue(data)).then(() => getActiveCountries());
let prefixSelector = document.getElementById("prefix");

// Getting the default loaded prefixes
// Use this if you want to work and modify the 
// values given by the user (loaded with the page, without modifications)
let loadedPrefixList = [];
for (let i = 0; i < prefixSelector.length; i++) {
    loadedPrefixList.push(prefixSelector[i]["value"]);
} 
prefixSelector.addEventListener("change", onPrefixChange);

let activeCountries = [];
let activeCountryIndex = 0;

// Get tracking id from url
let params = new URLSearchParams(location.search);
let trackingId = ";";
if (params.get("tracking") != null) {
    trackingId += params.get("tracking");
}

// Filter active countries
function getActiveCountries() {

    // Here you can change the way of filtering. 
    // Now assumes that there are country codes provided by default

    for (let i = 0; i < loadedPrefixList.length; i++) {
        for (let j = 0; j < allCountries.length; j++) {
            if (allCountries[j]["countryCode"] == loadedPrefixList[i]) {
                activeCountries.push(allCountries[j]);
                break;
            }
        }
    }

    str = "";
    for (let i = 0; i < allCountries.length; i++) {
        str += allCountries[i]["countryCode"] + ",";
    }

    activeCountries.sort((a,b) => (a.countryCode < b.countryCode) ? -1 : (a.countryCode > b.countryCode) ? 1 : 0);

    listActiveCountries();
    updateInputFieldProperties();
}

function listActiveCountries() {
    // Fill the prefix selector with the list of active countries
    // Feel free to modify the format
    prefixSelector.innerHTML = "";
    for (var i = 0; i < activeCountries.length; i++) {
        prefixSelector.innerHTML += "<option value = '" + activeCountries[i]["countryPrefix"] + "'>" + "("+ activeCountries[i]["countryCode"] + ") " + activeCountries[i]["countryPrefix"] + "</option>";
    }
}

// Load all countries
function passValue(data) {
    for (let i = 0; i < data.length; i++) {
        allCountries.push(data[i]);
    }
}

// Call this on prefix change
function onPrefixChange() {
    document.getElementById("custom_phone_number").value = "";
    for (var i = 0; i < activeCountries.length; i++) {
        if (activeCountries[i]["countryPrefix"] == prefixSelector.value) {
            activeCountryIndex = i;
        }
    }
    updateInputFieldProperties();
}

// Modifies the input field to only accept the correct number of characters
// and to display the correct placeholder text
function updateInputFieldProperties() {
    document.getElementById("custom_phone_number").pattern = activeCountries[activeCountryIndex]["pattern"];
    document.querySelector("label[for='phone_number']").innerHTML = activeCountries[activeCountryIndex]["placeholder"];
}

function updateInputValue() {
    document.getElementsByName("customer[note]")[0].value = document.getElementById("prefix").value + document.getElementById("custom_phone_number").value + trackingId;
}

// Custom validation. Currently not used.
// TODO: Handle the '+' in the prefix, because currently it counts to the total length
function validatePhoneNumber() {

    // Determine the index of the selected country
    let selectorIndex = -1;
    for (let i = 0; i < activeCountries.length; i++) {
        if (prefixSelector.value === activeCountries[i]["countryPrefix"]) {
            selectorIndex = i;
        }
    }

    let enteredPhoneNumber = document.getElementById("custom_phone_number").value.toString();

    // Checks the phone number length
    // Don't forget to change if you want from the user to enter the whole phone number

    if (enteredPhoneNumber.length + activeCountries[selectorIndex]['countryPrefix'].length !== activeCountries[selectorIndex]['countryTotalPhoneLength']) {
        return false;
    }

    // Checks the country prefix.
    // Use if you wish to allow the user to enter the whole phone number

    /* for (var i = 0; i < activeCountries[selectorIndex]['countryPrefix'].length; i++) {
        if (activeCountries[selectorIndex]['countryPrefix'][i] != enteredPhoneNumber[i]) {
            return false;
        }
    } */

    return true;
}